import DetailsAddress from './DetailsAddress'
import DetailsData from './DetailsData'

const AccountDetails = () => {
  return (
    <div className='account__details'>
      <DetailsData />
      <DetailsAddress />
    </div>
  )
}

export default AccountDetails
